// src/pages/admin/manager/ManagerLayout.tsx
import { Outlet } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function ManagerLayout() {
  const { t } = useTranslation<"translation">();

  return (
    <Box p={3}>
      <Typography variant="h4" mb={2}>
      </Typography>

      {/* aquí se renderizan las sub-páginas */}
      <Outlet />
    </Box>
  );
}
